import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import { forgotPasswordApi } from "@/utils/apis/auth-service";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useForgotPassword = () => {
    const navigate = useNavigate()
    const { sendEvent } = useCreateEvent()
    const [emailErrorText, setEmailErrorText] = useState("")
    const [isLoading, setIsLoading] = useState(false)

    const onBackButtonClick = async () => {
        navigate("/login")
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "back_button",
        });
    }

    const handleInputSubmit = async (inputData: { [key: string]: string }) => {
        const email = inputData.email
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "submit_button",
            event_metadata: { action: "reset_password" }
        });
        callForgotPassword(email)
    }

    const callForgotPassword = (email: string) => {
        setEmailErrorText("")
        setIsLoading(true)
        forgotPasswordApi(
            email,
            async () => {
                setIsLoading(false)
                navigate("/forgot-password-insert-code", { state: { email } })
                await sendEvent({
                    event: EventType.CHANGE_PASSWORD_REQUEST_SUCCESS,
                    sub_category: "change_password",
                    event_metadata: { email }
                })
            },
            async (error) => {
                setIsLoading(false)
                setEmailErrorText(error)
                await sendEvent({
                    event: EventType.CHANGE_PASSWORD_REQUEST_FAILED,
                    sub_category: "change_password",
                    event_metadata: { email, error }
                })
            }
        )
    }

    return {
        onBackButtonClick,
        emailErrorText,
        isLoading,
        handleInputSubmit,
    }
}